import React from 'react';
import { FarmSectionHeader } from './FarmSectionHeader';
import { StatCardGlow } from './StatCardGlow';
import { Leaf, Tractor, Wallet } from 'lucide-react';
import { ArrowRightCircle, Users } from 'react-feather';
import { ActionCard } from './ActionCard';

export const GeneralUserDashboard = () => {
  return (
    <div className="space-y-12">
      <FarmSectionHeader title="Your Overview" icon={<Leaf className="text-green-700" />} />

      <div className="grid md:grid-cols-2 gap-6">
        <StatCardGlow
          title="Farms Joined"
          value={1}
          icon={<Tractor className="h-8 w-8 text-green-600" />}
        />

        <StatCardGlow
          title="Wallet Balance"
          value={34000}
          unit="UGX"
          icon={<Wallet className="h-8 w-8 text-green-600" />}
        />
      </div>

      <FarmSectionHeader
        title="Suggested Actions"
        icon={<ArrowRightCircle className="text-green-700" />}
      />

      <div className="grid md:grid-cols-2 gap-6">
        <ActionCard title="Join a Farm" link="/app/join" icon={<Users />} />
        <ActionCard title="Invest in a Farm" link="/funding" icon={<Wallet />} />
      </div>
    </div>
  );
};
